import React from 'react'
import { useEffect, useState } from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import DashHeader from '../mini/DashHeader';
import { Link } from "react-router-dom"
import UserStatusModal from "../mini/UserStatusModal"
import delIcon from "../../images/delete.svg"
import Pagination from "../mini/Pagination";
import { useAllUsersQuery, useDelUserMutation } from '../../redux/services/usersApi';
import { toast } from 'react-toastify';

const Users = () => {

    const [delUser, { isLoading: delLoading }] = useDelUserMutation()
    const { data, error, isLoading, isSuccess } = useAllUsersQuery()
    // let users

    useEffect(() => {
        if (!isLoading) {
            if (!isSuccess) {
                console.log(error)
                toast.error(error?.data?.message || error?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
            }
        }
      
    }, [isLoading, isSuccess, error, data])
    

    const [ openModal, setOpenModal ] = useState(false)
    const [ modalId, setModalId ] = useState(null)
    const [ moreModal, setMoreModal ] = useState(false)
    const [ moreId, setMoreId ] = useState(null)
    const [ deleteModal, setDeleteModal ] = useState(null)
    const [ searchQuery, setSearchQuery ] = useState('')

    // pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [dataPerPage] = useState(9)

    const indexOfLastData = currentPage * dataPerPage
    const indexOfFirstData = indexOfLastData - dataPerPage
    const currentTableDatas = data?.data.slice(indexOfFirstData, indexOfLastData)

    const paginate = pg => {
        setCurrentPage(pg)
    }

    let table

    if(searchQuery){
        table = data?.users
    } else {
        table = currentTableDatas
    }
            
    window.onclick = function(event) {

        const modal = document.querySelector("#modal")

        if (event.target === modal) {
            setOpenModal(false)
            setDeleteModal(null)
        }
    }

    const moreModalHandler = (mreId) => {
        setMoreId(mreId)
        setMoreModal(!moreModal)
    }


    const modalHandler = (userId) => {
        setModalId(userId)
        setOpenModal(!openModal)
    }


    const deleteModalHandler = (uid) => {
        setDeleteModal(uid)

        if (moreModal) {
            moreModalHandler()
        }
    }

    const deleteUser = async () => {
        if (!deleteModal) 
            return toast.error("User not provided", {
                position: toast.POSITION.TOP_RIGHT
            })

        await delUser({userId: deleteModal})
            .unwrap()
            .then((resp) => {
                console.log(resp)
                toast.success(resp?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
                deleteModalHandler(null)
            })
            .catch((error) => {
                console.log(error)
                toast.error(error?.data?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
            })
    }

    const renderList = table?.filter((val) => {
        return val.userStatus.toLowerCase().includes(searchQuery?.toLowerCase()) 
                    || val.fullName.toLowerCase().includes(searchQuery.toLowerCase())
                    || val.email.toLowerCase().includes(searchQuery.toLowerCase())
                    || val.phone.toLowerCase().includes(searchQuery.toLowerCase())
    }).map((user, index) => {
        
        const { _id, fullName, email, phone, userStatus } = user
        const oh = `/dashboard/order-history/${_id}`

        let txtColor = "text-decor c-pointer "

        if (userStatus === "pending") {
            txtColor += "text-warning"            
        } else if (userStatus === "active") {
            txtColor += "text-success" 
        } else {
            txtColor += "text-danger"
        }


        return (
            <tr key={index} className="p-relative">
                <td>{index+1}</td>
                <td>{fullName}</td>
                <td>{email}</td>
                <td>{phone}</td>
                <td><Link to={oh} className="text-primary">Order History</Link></td>
                <td onClick={() => modalHandler(_id)} className={txtColor}>{userStatus}</td>
                <td>
                    <i onClick={() => moreModalHandler(index)} className="ri-more-2-line btn p-1"></i>
                    { moreModal && moreId === index ? 
                        <>
                            <div className="bg-white rounded text-start fw-bold more-opts p-2 py-3">
                                <button className="btn btn-basic p-1 mt-1 fw-bold" onClick={() => deleteModalHandler(_id)}><i className="ri-delete-bin-line me-2"></i> Delete</button>
                            </div>
                            <div className="modal d-block" id={"opts"+_id} onClick={() => moreModalHandler()}>
                            </div>
                        </>
                    : '' }
                </td>
            </tr>
        )

    })


    return (
        <>
            {
                isLoading ?
                <div className="loader">
                    <ClipLoader color="#fdc51c" loading={isLoading} size={80} /> 
                </div> :
                <div className='pull-up'>
                    <DashHeader title="Users" />
                    <section>
                        {/* modals */}
                        { openModal && (<UserStatusModal  closer={() => modalHandler(null)} uId={modalId} />) }

                        { deleteModal ? 
                        <div className="modal d-block" id="modal">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content p-3 px-4 pull-up text-center">

                                    <div className="text-end">
                                        <button type="button" className="btn pt-0 pe-0" onClick={() => deleteModalHandler(null)}><i className="ri-close-line ri-xl"></i></button>
                                    </div>
                                    <div className="pb-3 px-5">
                                        <img src={delIcon} alt="" />
                                        <h5 className='mt-3'>Are you sure?</h5>
                                        <p className='mt-3'>You might lose all your information. You can't undo this action</p>
                                    </div>
                                    <div className="pb-5 px-4">
                                        <button type="button" className="btn btn-danger" onClick={deleteUser}>
                                            { delLoading ? <ClipLoader size={20} /> : "DELETE" }
                                        </button>
                                        <button type="button" className="btn border-light ms-3" onClick={() => deleteModalHandler(null)}>CANCEL</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        : '' }

                        {/* search */}
                        <div>
                            <div className="input form-control w-40 py-0 my-1 me-5">
                                <i className="ri-search-line ri-lg pe-2"></i>
                                <input type="text" placeholder="Search Users By Name, Email, Phone or Status" className="w-75 p-2 ps-0" value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}} />
                            </div>
                        </div>
                        

                        {/* table */}
                        <div className="table-responsive my-4 pb-5">
                            <table className="table text-center">
                                <thead>
                                    <tr className="grey-bg">
                                        <th>No</th>
                                        <th>User's Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Order History</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {renderList}
                                </tbody>
                            </table>
                        </div>
                        <Pagination 
                        paginate={paginate} 
                        dataPerPage={dataPerPage} 
                        totalData={data?.data.length}
                        curPage={currentPage}
                        pageLen={currentTableDatas?.length} />
                    </section>
                </div>
            }
        </>
    )
}

export default Users
